import React from "react";
import { Row, Col } from "@mtm/components";
import { Button, Typography, Card, Avatar } from "antd";
import Styles from "./ScheduleService.module.scss";
import { usersImage } from "../../assets/images";

const NewScheduleService: React.FC<{
  onAddNew: () => void;
}> = ({ onAddNew }) => {
  return (
    <Card hoverable bordered className={Styles.newSelectCardBoard}>
      <Row justify="center" className={Styles.cardInsideTopPadding}>
        <Col>
          <Avatar size={75} icon={<img alt="Profile" src={usersImage} />} />
        </Col>
      </Row>
      <Row justify="center" className={Styles.cardInsideTopPadding}>
        <Col>
          <Row justify="center">
            <Col>
              {" "}
              <Typography.Text className={Styles.addNew}>
                Add New
              </Typography.Text>
            </Col>
          </Row>
          <Row justify="center">
            <Col>
              {" "}
              <Typography.Text className={Styles.serviceUserText}>
                Service User
              </Typography.Text>
            </Col>
          </Row>
        </Col>
      </Row>
      <Row justify="center" className={Styles.cardInsideTopPadding}>
        <Col>
          <Button
            type="primary"
            onClick={onAddNew}
            className={Styles.buttonNewSelect}
          >
            Select
          </Button>
        </Col>
      </Row>
    </Card>
  );
};

export default React.memo(NewScheduleService);
